import styles from "./VWSpace.module.css";
export default function VWSpace(props :{height :string;}){
    return(<div className={styles.VWSpace} style={{height: props.height}}></div>);
}